import { useQuery } from "@apollo/client/react";
import { TENANTS_USERS_LIST } from "../";

type TenantUser = {
  id: string;
  name: string;
  email: string;
  countryCode: string;
  timezone: string;
  roles: string[];
  lang: string;
  companyId: string;
  partner?: { name?: string } | null;
  status: string;
  isVerified?: boolean;
  lastLogin: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * Custom hook to fetch and format the partner users list.
 * @returns {{usersList: Array<{id: string, name: string, email: string, countryCode: string, timezone: string, roles: Array<string>, lang: string, companyId: string, partner: any, partnerName: string}>, loading: boolean}} - The formatted partner users list and loading state.
 * @param tenantId
 */
export function useTenantUsersList(tenantId: string | undefined) {
  const skip = !tenantId;

  const { data, loading } = useQuery<any>(TENANTS_USERS_LIST, {
    variables: {
      tenantId,
    },
    skip,
  });

  // Extracting the necessary data and formatting it as needed
  const formattedData =
    data?.tenantsUsersList.map((user: TenantUser) => ({
      id: user.id,
      name: user.name,
      email: user.email,
      countryCode: user.countryCode,
      timezone: user.timezone,
      roles: user.roles,
      lang: user.lang,
      companyId: user.companyId,
      partner: user.partner,
      status: user.status,
      isVerified: Boolean(user.isVerified),
      lastLogin: user.lastLogin,
      createdAt: user.createdAt,
      updatedAt: user.updatedAt,
      partnerName: user.partner ? user.partner.name : "N/A", // Accessing partner's name
    })) || [];

  return {
    usersList: formattedData,
    loading,
  };
}
